const loadGoogleMaps = (callback: () => void) => {
  // If already loaded, return immediately
  if (window.google && window.google.maps) {
    callback();
    return;
  }

  // Prevent duplicate script injections (React 18 StrictMode runs effects twice in dev)
  const LOADER_FLAG = '__gmaps_loading__';
  const SCRIPT_ID = 'gmaps-js-api';
  const w = window as any;

  if (w[LOADER_FLAG]) {
    // Another load is in progress; attach a temporary listener for the init callback
    (w.__gmapsInitQueue__ = w.__gmapsInitQueue__ || []).push(callback);
    return;
  }

  const existingScript = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
  if (existingScript) {
    w[LOADER_FLAG] = true;
    (w.__gmapsInitQueue__ = w.__gmapsInitQueue__ || []).push(callback);
    return;
  }

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  console.log('🔑 Google Maps API Key check:', {
    hasApiKey: !!apiKey,
    apiKeyLength: apiKey?.length || 0,
    isPlaceholder: apiKey === 'YOUR_API_KEY' || apiKey === 'your_google_maps_api_key_here'
  });

  if (!apiKey || apiKey === 'YOUR_API_KEY' || apiKey === 'your_google_maps_api_key_here') {
    console.warn('⚠️ Google Maps API key not found or is placeholder. Please set REACT_APP_GOOGLE_MAPS_API_KEY in your environment variables.');
    // Still call the callback to prevent the app from hanging
    callback();
    return;
  }

  // Mark as loading and inject script once
  w[LOADER_FLAG] = true;
  (w.__gmapsInitQueue__ = w.__gmapsInitQueue__ || []).push(callback);

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,marker&callback=initGoogleMaps`;
  script.async = true;
  script.defer = true;
  document.body.appendChild(script);

  // Attach callback to window and flush queue once ready
  w.initGoogleMaps = () => {
    try {
      const queue: Array<() => void> = w.__gmapsInitQueue__ || [];
      queue.forEach(fn => {
        try { fn(); } catch (e) { console.error('Error in Google Maps init callback:', e); }
      });
    } finally {
      w[LOADER_FLAG] = false;
      w.__gmapsInitQueue__ = [];
    }
  };
};

export default loadGoogleMaps;
